import ReactModal from "react-modal";
import TierList from "../components/tierList";
import { nationalParksList } from "../../lists/nationalParkList";
import { useCallback, useState } from "react";

export default function TravelParks() {

  const [showModal, setShowModal] = useState(false);
  const handleOpenModal = useCallback((index) => {
    setShowModal(true);
  }, []);
  const handleCloseModal = useCallback((index) => {
    setShowModal(false);
  }, []);

  return (
    <>
      <div className="artwork-tape-header container">
        <div className="row">
          <div className="col-12">
            <div className="artwork-tape-header-titles">National Parks</div>
            <p className="align-center">50/63 Parks Visted </p>
            <div className="league-table d-none d-lg-block travel-table-center">
              Remaing Parks:
              <ul>
                <li>Other: Congaree, Isle Royale</li>
                <li>Pacfic: Haleakala, Hawaii Volcanoes, American Samoa</li>
                <li>Alaksa: Denali, Kenai Fjords, Glacier Bay, Gates of the Arctic,  Katmai, Kobuk Valley, Lake Clark, Wrangell-St. Elias</li>
              </ul>

            </div>
            <div className="gaming-tier-list-button" onClick={handleOpenModal}>
              <div className="index-card-header">National Parks Tier List</div>
            </div>
            <img className="usa-map" alt="parks-traveled" src={process.env.PUBLIC_URL + "/images/experiences/np1.png"} />

          </div>
        </div>
      </div>
      <div className="mt-5 col-12 col-md-4">
        <ReactModal
          isOpen={showModal}
          contentLabel="Minimal Modal Example"
        >

          <TierList
            title="U.S. States"
            items={nationalParksList}
            tiers={["S", "A", "B", "C", "F", "NA"]}
            columns={3}
          />
          <button onClick={handleCloseModal}>Close Window</button>
        </ReactModal>
      </div>
    </>
  )
}

